@if (display) {
<div class="bg-col-4">
    <div class="p-a p-t-6 m-t m-b"
         style="background-color: #FFF2C7;">
        <div class="w-1 center-x center-l">
            @if (donationBaseImage) {
            <div class="ratio-1-1 w-6 w-8-s">
                <img class="rf"
                     dynamic="1"
                     [image]="donationBaseImage">
            </div>
            }
        </div>
        <div class="w-11">
            <p class="s1">{{donationPurposeName}}</p>
            <div class="flex flex-justify-between m-t-2">
                <p class="p2 col-1"><span>{{'Donate' | translate}} </span>
                    <price [value]="donationPrice"
                           [precision]="2"></price>&nbsp;{{'to %' | translate : donationPurpose}}
            </div>
        </div>
        <form #form="ngForm"
              method="POST"
              class="m-t-2 p-l-3-x p-l-3-l w-11 pos-relative">
            <checkbox [(ngModel)]="donation"
                      class="p-l-8 p-l-7-s p-l-10-m m-l-1-m donation-checkbox"
                      name="donation"
                      [ngClass]="{'is-disabled cursor-wait':isBusy}">
                <span class="p2">{{donationDescription}}</span>&nbsp;
                @if (donationMoreInfoUrl) {
                <a class="italic underline p2 inline"
                   [attr.href]="donationMoreInfoUrl"
                   target="_blank">{{'More info' | translate}}</a>
                }
            </checkbox>
        </form>
        <div class="w-12">
            <div class="w-1"></div>
            @if (donationExtraImage) {
            <div class="ratio-5-2 w-4 w-6-s">
                <img class="rf"
                     [image]="donationExtraImage"
                     [options]="{fitIn:true, fillColor:'transparent'}">
            </div>
            }
            <result class="block w-12 center"
                    [status]="status"></result>
        </div>
    </div>
</div>
}